import {
  Layers, Wrench, Cog, Zap, CircuitBoard, Box, Hammer, Gauge,
  FoldVertical, Dot, Flame, Sparkles, Paintbrush, PackageCheck, Factory,
} from "lucide-react";
import { Reveal } from "../motion";
import { Eyebrow, GhostButton } from "../CTA";
import { SERVICES } from "../../lib/site";

const icons = {
  Layers, Wrench, Cog, Zap, CircuitBoard, Box, Hammer, Gauge,
  FoldVertical, Dot, Flame, Sparkles, Paintbrush, PackageCheck, Factory,
};

const ServiceCard = ({ s, i }) => {
  const Icon = icons[s.icon] || Cog;
  return (
    <Reveal delay={(i % 3) * 0.06}>
      <div
        className="group relative h-full overflow-hidden rounded-3xl border border-navy/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand/30 hover:shadow-[0_20px_50px_rgba(10,17,40,0.08)]"
        data-testid={`service-card-${i}`}
      >
        <div className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-brand transition-transform duration-300 group-hover:scale-x-100" />
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-surface text-navy transition-colors duration-300 group-hover:bg-navy group-hover:text-white">
          <Icon className="h-6 w-6" />
        </div>
        <h3 className="mt-6 font-display text-xl font-semibold text-navy">{s.title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
      </div>
    </Reveal>
  );
};

const ServicesGrid = ({ preview = false }) => {
  const list = preview ? SERVICES.slice(0, 6) : SERVICES;
  return (
    <section className="relative bg-white py-24 sm:py-32" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Eyebrow>Our Services</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
              End-to-end manufacturing,
              <br />
              <span className="text-steel">under one precision roof.</span>
            </h2>
          </div>
          {preview && <GhostButton to="/services" testId="services-viewall-btn">All Services</GhostButton>}
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((s, i) => (
            <ServiceCard key={s.title} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
